import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../../1_Atoms/Svg/Svg'
import { closeModal } from '../../../utils/helpers';

function Modal({
  className,
  isOpen,
  isDark,
  children,
  onClose,
  modalRef,
  ...otherProps
}) {
  return (
    <div
      className={`mz-modal mz-react-form-modal ${className}`}
      aria-hidden={!isOpen}
      ref={modalRef}
      {...otherProps}
    >
      <div className="mz-modal__inner mz-container">
        <div className="mz-modal__wrapper mz-full-width">
          <div className="mz-modal__close">
            <button
              className="mz-modal-close-button reset"
              aria-label="Close Modal"
              onClick={() => {
                if (modalRef && modalRef.current) {
                  closeModal(modalRef.current);
                }
                if (onClose) {
                  onClose();
                }
              }}
            >
              <Svg
                type="x"
                size={1.875}
                colour={isDark ? 'white' : 'grey'}
              />
            </button>
          </div>
          <div className="mz-modal__content">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  isDark: PropTypes.bool,
  onClose: PropTypes.func,
  modalRef: PropTypes.object,
};

Modal.defaultProps = {
  isOpen: false,
  isDark: false,
  onClose: undefined,
  modalRef: null,
}

export default Modal

